export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

/** Vite mode string (e.g. development, production). Use for namespacing; do not branch features on this alone. */
export const APP_BUILD_MODE = import.meta.env.MODE || "development";

/** Deploy branch label from Vite env (defaults to dev when unset). */
export const VITE_USER_BRANCH = import.meta.env.VITE_USER_BRANCH || "dev";

/**
 * Google Maps / Places JavaScript API key (Vite client bundle).
 * SECURITY: Restrict key by HTTP referrer in Google Cloud Console.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "";

/** Map ID for Advanced Markers (e.g. Parcel Search). */
export const GOOGLE_MAPS_PARCEL_SEARCH_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_PARCEL_SEARCH_MAP_ID ?? "";

/** Full URL to the `search-investors-by-property` Supabase Edge Function. */
export const SUPABASE_SEARCH_INVESTORS_URL = import.meta.env.VITE_SUPABASE_SEARCH_INVESTORS_URL ?? "";

/**
 * Supabase function `x-api-key` header. VITE_ exposes this to the client bundle.
 * RISK: Capability token visible in the browser; use a BFF if you need stronger protection.
 */
export const SUPABASE_API_KEY = import.meta.env.VITE_SUPABASE_API_KEY ?? "";

/** Userflow.js onboarding token (used only when USERFLOW_ENABLED is true). */
export const USERFLOW_TOKEN = import.meta.env.VITE_USERFLOW_TOKEN ?? "";

/** Userflow.js integration master switch — set true when the account is active again. */
export const USERFLOW_ENABLED = false;